export enum CreateSupplierModalProps {
  CANCEL_BUTTON_LABEL = 'Cancel',
  CREATE_BUTTON_LABEL = 'Create',
  EDIT_BUTTON_LABEL = 'Submit',
  MODAL_HEADING_CREATE = 'Create Supplier',
  MODAL_HEADING_EDIT = 'Edit Supplier',
  EMPTY_STRING = '',
  MODAL_WIDTH = 725,
  CITY = 'city',
  PROVINCE = 'province',
  COUNTRY = 'country',
}

export enum ValidationSchema{
  ERROR_MESSAGE = "Required",
  NUMBER = 'Value should be a number',
  NO_SPECIAL_CHARACTER= "Please don't use special characters"
}